import React from 'react';

const TeamMemberEditLoading = () => {
    return <div>Loading...</div>;
};

export default TeamMemberEditLoading;

